export default function videoReviewsController() {
  const videoReviews = document.querySelector('.video-reviews');
  if (!videoReviews) return;

  const gallery = GLightbox({
    selector: '.video-reviews__item',
    touchNavigation: true,
    loop: true,
    autoplayVideos: true,
  });
}
